import React from "react"
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import RetroUpdaterComponent from './retro-updater-component'
import * as actionCreators from "./../../../action-creators"
import * as actions from '../../../actions'
import Operations from '../../../component/scenarii/common/operations'
import * as Model from '../../../model'
import ScenarioService from '../../../service/sfp/scenario-service'


class RetroUpdaterContainer extends React.Component {

	state = {
		/** @type {DataRow[]} */
		data: null,
		submitting: false
	}

	render() {
		return (
			<RetroUpdaterComponent
				scenario={this.props.scenario}
				submitting={this.state.submitting}
				onRetroUpdated={this._handleUpdateRetro.bind(this)}
			/>
		)
	}

	_handleUpdateRetro() {
		/** @type {Model.LocalAuthority} */
		const localAuthority = this.props.localAuthority
		/** @type {Model.Ppi} */
		const ppi = this.props.ppi
		/** @type {Model.Scenario} */
		const scenario = this.props.scenario

		const operations = new Operations(scenario, ppi, localAuthority)
		const data = localAuthority.accounts.reduce((prevData, laca) => {
			if (!laca.account.operation) return prevData

			var rValue = laca.account.receipts ? operations.findValue(scenario.year, laca.account.id, laca.chapter ? laca.chapter.id : -1) : null
			var eValue = laca.account.expense ? operations.findValue(scenario.year, laca.account.id, laca.chapter ? laca.chapter.id : -1) : null
			const rValueIsDefined = undefined !== rValue && null !== rValue
			const eValueIsDefined = undefined !== eValue && null !== eValue

			if (rValueIsDefined || eValueIsDefined) {
				prevData.push({
					account: laca.account,
					receipts: rValue,
					expenses: eValue,
				})
			}

			return prevData
		}, [])

		this.setState({ data, submitting: true }, () => {
			ScenarioService.updateRetro(scenario, data)
			.then(::this._resolveRetroUpdated, ::this._rejectRetroUpdated);
		})
	}

	_resolveRetroUpdated(/** @type {Model.Observation[]} */ observations) {
		this.setState({submitting: false}, () => {
			this._updateCurrenLocalAuthority(observations)
			this.props.onRetroUpdated(observations)
		})
	}

	_rejectRetroUpdated(error) {
		this.setState({submitting: false})
		this.props.actions.throwError(error);
	}

	_updateCurrenLocalAuthority(/** @type {Model.Observation[]} */ observations) {
		/** @type {Model.LocalAuthority} */
		const localAuthority = this.props.localAuthority
		localAuthority.observations = observations

		this.props.actions.updateCurrentLocalAuthority(localAuthority)
	}
}

const mapDispatchToProps = dispatch => (
  { actions: bindActionCreators(actions, dispatch)},
  { actionCreators :bindActionCreators(actionCreators, dispatch)}
)

export default connect(undefined, mapDispatchToProps)(RetroUpdaterContainer)

/**
 * @typedef {Object} DataRow
 * @property {Model.Account} account
 * @property {number} receipts
 * @property {number} expenses
 */



// WEBPACK FOOTER //
// ./src/component/scenarii/manager/retro-updater-container.js